const LABELS = {
  PENDING: '승인 대기',
  APPROVED: '승인',
  REJECTED: '거절',
}

export function signupRequestStatusLabel(status) {
  if (status == null || status === '') return '-'
  return LABELS[status] ?? String(status)
}
